import './assets/index48.css';var Ae = Object.defineProperty, _e = Object.defineProperties;
var ke = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols;
var pe = Object.prototype.hasOwnProperty, ce = Object.prototype.propertyIsEnumerable;
var le = (e, o, t) => o in e ? Ae(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t, n = (e, o) => {
  for (var t in o || (o = {}))
    pe.call(o, t) && le(e, t, o[t]);
  if ($)
    for (var t of $(o))
      ce.call(o, t) && le(e, t, o[t]);
  return e;
}, c = (e, o) => _e(e, ke(o));
var j = (e, o) => {
  var t = {};
  for (var r in e)
    pe.call(e, r) && o.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && $)
    for (var r of $(e))
      o.indexOf(r) < 0 && ce.call(e, r) && (t[r] = e[r]);
  return t;
};
import { jsxs as Q, Fragment as fe, jsx as x } from "react/jsx-runtime";
import $e, { useState as me, useRef as he, useCallback as ve, useEffect as je, cloneElement as ge, useContext as Be, createContext as Ue } from "react";
import { f as ye, u as B, b as We, B as we, h as Pe, c as Ye } from "./factory-ueRxoNOV.js";
import { i as be } from "./is-element-C00Aie10.js";
import { g as Te, O as xe } from "./OptionalPortal-sP4Hf4UO.js";
import { e as Re } from "./get-size-Bc1Pz5yf.js";
import { g as De, u as He, a as Je, F as Ve } from "./use-floating-auto-update-Bm7DFrip.js";
import { c as Oe } from "./create-vars-resolver-Bzbn9G-G.js";
import { u as Me } from "./use-styles-DToiHEa6.js";
import { u as Xe } from "./DirectionProvider-CT8S13Cp.js";
import { T as Ze } from "./Transition-esp-rpzm.js";
import { g as qe } from "./get-style-object-D6Nwi4P2.js";
import { u as Fe, s as Ee, g as Ke, F as Qe, d as eo, e as oo, h as to, j as ro, k as no, m as so, o as ao, f as de, b as io, i as K } from "./floating-ui.react-DiT1zkFi.js";
import { u as Ce } from "./use-merged-ref-n551Tfbr.js";
import { u as lo } from "./use-id-D2tGiO9x.js";
import { u as po } from "./use-reduced-motion-C9DbPZfj.js";
const co = {
  duration: 100,
  transition: "fade"
};
function uo(e, o) {
  return n(n(n({}, co), o), e);
}
function fo({
  offset: e,
  position: o,
  defaultOpened: t
}) {
  const [r, i] = me(t), h = he(null), { x: s, y: v, elements: P, refs: d, update: a, placement: g } = Fe({
    placement: o,
    middleware: [
      Ee({
        crossAxis: !0,
        padding: 5,
        rootBoundary: "document"
      })
    ]
  }), D = g.includes("right") ? e : o.includes("left") ? e * -1 : 0, b = g.includes("bottom") ? e : o.includes("top") ? e * -1 : 0, y = ve(
    ({ clientX: l, clientY: p }) => {
      d.setPositionReference({
        getBoundingClientRect() {
          return {
            width: 0,
            height: 0,
            x: l,
            y: p,
            left: l + D,
            top: p + b,
            right: l,
            bottom: p
          };
        }
      });
    },
    [P.reference]
  );
  return je(() => {
    if (d.floating.current) {
      const l = h.current;
      l.addEventListener("mousemove", y);
      const p = Ke(d.floating.current);
      return p.forEach((m) => {
        m.addEventListener("scroll", a);
      }), () => {
        l.removeEventListener("mousemove", y), p.forEach((m) => {
          m.removeEventListener("scroll", a);
        });
      };
    }
  }, [P.reference, d.floating.current, a, y, r]), { handleMouseMove: y, x: s, y: v, opened: r, setOpened: i, boundaryRef: h, floating: d.setFloating };
}
var U = { tooltip: "m_1b3c8819", arrow: "m_f898399f" };
const mo = {
  refProp: "ref",
  withinPortal: !0,
  offset: 10,
  defaultOpened: !1,
  position: "right",
  zIndex: Te("popover")
}, ho = Oe((e, { radius: o, color: t }) => ({
  tooltip: {
    "--tooltip-radius": o === void 0 ? void 0 : Re(o),
    "--tooltip-bg": t ? Pe(t, e) : void 0,
    "--tooltip-color": t ? "var(--mantine-color-white)" : void 0
  }
})), ee = ye((e, o) => {
  var _, k;
  const t = B("TooltipFloating", mo, e), A = t, {
    children: r,
    refProp: i,
    withinPortal: h,
    style: s,
    className: v,
    classNames: P,
    styles: d,
    unstyled: a,
    radius: g,
    color: D,
    label: b,
    offset: y,
    position: l,
    multiline: p,
    zIndex: m,
    disabled: N,
    defaultOpened: O,
    variant: M,
    vars: F,
    portalProps: R
  } = A, E = j(A, [
    "children",
    "refProp",
    "withinPortal",
    "style",
    "className",
    "classNames",
    "styles",
    "unstyled",
    "radius",
    "color",
    "label",
    "offset",
    "position",
    "multiline",
    "zIndex",
    "disabled",
    "defaultOpened",
    "variant",
    "vars",
    "portalProps"
  ]), C = We(), u = Me({
    name: "TooltipFloating",
    props: t,
    classes: U,
    className: v,
    style: s,
    classNames: P,
    styles: d,
    unstyled: a,
    rootSelector: "tooltip",
    vars: F,
    varsResolver: ho
  }), { handleMouseMove: W, x: I, y: L, opened: Y, boundaryRef: H, floating: J, setOpened: z } = fo({
    offset: y,
    position: l,
    defaultOpened: O
  });
  if (!be(r))
    throw new Error(
      "[@mantine/core] Tooltip.Floating component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
    );
  const V = Ce(H, De(r), o), w = r.props, X = (G) => {
    var T;
    (T = w.onMouseEnter) == null || T.call(w, G), W(G), z(!0);
  }, Z = (G) => {
    var T;
    (T = w.onMouseLeave) == null || T.call(w, G), z(!1);
  };
  return /* @__PURE__ */ Q(fe, { children: [
    /* @__PURE__ */ x(xe, c(n({}, R), { withinPortal: h, children: /* @__PURE__ */ x(
      we,
      c(n(n({}, E), u("tooltip", {
        style: c(n({}, qe(s, C)), {
          zIndex: m,
          display: !N && Y ? "block" : "none",
          top: (_ = L && Math.round(L)) != null ? _ : "",
          left: (k = I && Math.round(I)) != null ? k : ""
        })
      })), {
        variant: M,
        ref: J,
        mod: { multiline: p },
        children: b
      })
    ) })),
    ge(r, c(n({}, w), {
      [i]: V,
      onMouseEnter: X,
      onMouseLeave: Z
    }))
  ] });
});
ee.classes = U;
ee.displayName = "@mantine/core/TooltipFloating";
const Ge = Ue(!1), vo = Ge.Provider, go = () => Be(Ge), yo = {
  openDelay: 0,
  closeDelay: 0
};
function oe(e) {
  const { openDelay: o, closeDelay: t, children: r } = B("TooltipGroup", yo, e);
  return /* @__PURE__ */ x(vo, { value: !0, children: /* @__PURE__ */ x(Qe, { delay: { open: o, close: t }, children: r }) });
}
oe.displayName = "@mantine/core/TooltipGroup";
oe.extend = (e) => e;
function wo(e) {
  if (e === void 0)
    return { shift: !0, flip: !0 };
  const o = n({}, e);
  return e.shift === void 0 && (o.shift = !0), e.flip === void 0 && (o.flip = !0), o;
}
function Po(e) {
  const o = wo(e.middlewares), t = [ao(e.offset)];
  return o.shift && t.push(
    Ee(
      typeof o.shift == "boolean" ? { padding: 8 } : n({ padding: 8 }, o.shift)
    )
  ), o.flip && t.push(
    typeof o.flip == "boolean" ? de() : de(o.flip)
  ), t.push(io({ element: e.arrowRef, padding: e.arrowOffset })), o.inline ? t.push(
    typeof o.inline == "boolean" ? K() : K(o.inline)
  ) : e.inline && t.push(K()), t;
}
function bo(e) {
  var R, E, C;
  const [o, t] = me(e.defaultOpened), i = typeof e.opened == "boolean" ? e.opened : o, h = go(), s = lo(), v = ve(
    (u) => {
      t(u), u && N(s);
    },
    [s]
  ), {
    x: P,
    y: d,
    context: a,
    refs: g,
    update: D,
    placement: b,
    middlewareData: { arrow: { x: y, y: l } = {} }
  } = Fe({
    strategy: e.strategy,
    placement: e.position,
    open: i,
    onOpenChange: v,
    middleware: Po(e)
  }), { delay: p, currentId: m, setCurrentId: N } = eo(a, { id: s }), { getReferenceProps: O, getFloatingProps: M } = oo([
    to(a, {
      enabled: (R = e.events) == null ? void 0 : R.hover,
      delay: h ? p : { open: e.openDelay, close: e.closeDelay },
      mouseOnly: !((E = e.events) != null && E.touch)
    }),
    ro(a, { enabled: (C = e.events) == null ? void 0 : C.focus, visibleOnly: !0 }),
    no(a, { role: "tooltip" }),
    // Cannot be used with controlled tooltip, page jumps
    so(a, { enabled: typeof e.opened == "undefined" })
  ]);
  He({
    opened: i,
    position: e.position,
    positionDependencies: e.positionDependencies,
    floating: { refs: g, update: D }
  }), po(() => {
    var u;
    (u = e.onPositionChange) == null || u.call(e, b);
  }, [b]);
  const F = i && m && m !== s;
  return {
    x: P,
    y: d,
    arrowX: y,
    arrowY: l,
    reference: g.setReference,
    floating: g.setFloating,
    getFloatingProps: M,
    getReferenceProps: O,
    isGroupPhase: F,
    opened: i,
    placement: b
  };
}
const ue = {
  position: "top",
  refProp: "ref",
  withinPortal: !0,
  inline: !1,
  defaultOpened: !1,
  arrowSize: 4,
  arrowOffset: 5,
  arrowRadius: 0,
  arrowPosition: "side",
  offset: 5,
  transitionProps: { duration: 100, transition: "fade" },
  events: { hover: !0, focus: !1, touch: !1 },
  zIndex: Te("popover"),
  positionDependencies: [],
  middlewares: { flip: !0, shift: !0, inline: !1 }
}, To = Oe((e, { radius: o, color: t }) => ({
  tooltip: {
    "--tooltip-radius": o === void 0 ? void 0 : Re(o),
    "--tooltip-bg": t ? Pe(t, e) : void 0,
    "--tooltip-color": t ? "var(--mantine-color-white)" : void 0
  }
})), S = ye((e, o) => {
  const t = B("Tooltip", ue, e), se = B("Tooltip", ue, t), {
    children: r,
    position: i,
    refProp: h,
    label: s,
    openDelay: v,
    closeDelay: P,
    onPositionChange: d,
    opened: a,
    defaultOpened: g,
    withinPortal: D,
    radius: b,
    color: y,
    classNames: l,
    styles: p,
    unstyled: m,
    style: N,
    className: O,
    withArrow: M,
    arrowSize: F,
    arrowOffset: R,
    arrowRadius: E,
    arrowPosition: C,
    offset: u,
    transitionProps: W,
    multiline: I,
    events: L,
    zIndex: Y,
    disabled: H,
    positionDependencies: J,
    onClick: z,
    onMouseEnter: V,
    onMouseLeave: w,
    inline: X,
    variant: Z,
    keepMounted: A,
    vars: _,
    portalProps: k,
    mod: G,
    floatingStrategy: T,
    middlewares: Ne
  } = se, Se = j(se, [
    "children",
    "position",
    "refProp",
    "label",
    "openDelay",
    "closeDelay",
    "onPositionChange",
    "opened",
    "defaultOpened",
    "withinPortal",
    "radius",
    "color",
    "classNames",
    "styles",
    "unstyled",
    "style",
    "className",
    "withArrow",
    "arrowSize",
    "arrowOffset",
    "arrowRadius",
    "arrowPosition",
    "offset",
    "transitionProps",
    "multiline",
    "events",
    "zIndex",
    "disabled",
    "positionDependencies",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "inline",
    "variant",
    "keepMounted",
    "vars",
    "portalProps",
    "mod",
    "floatingStrategy",
    "middlewares"
  ]), { dir: Ie } = Xe(), te = he(null), f = bo({
    position: Je(Ie, i),
    closeDelay: P,
    openDelay: v,
    onPositionChange: d,
    opened: a,
    defaultOpened: g,
    events: L,
    arrowRef: te,
    arrowOffset: R,
    offset: typeof u == "number" ? u + (M ? F / 2 : 0) : u,
    positionDependencies: [...J, r],
    inline: X,
    strategy: T,
    middlewares: Ne
  }), q = Me({
    name: "Tooltip",
    props: t,
    classes: U,
    className: O,
    style: N,
    classNames: l,
    styles: p,
    unstyled: m,
    rootSelector: "tooltip",
    vars: _,
    varsResolver: To
  });
  if (!be(r))
    throw new Error(
      "[@mantine/core] Tooltip component children should be an element or a component that accepts ref, fragments, strings, numbers and other primitive values are not supported"
    );
  const Le = Ce(f.reference, De(r), o), re = uo(W, { duration: 100, transition: "fade" }), ne = r.props;
  return /* @__PURE__ */ Q(fe, { children: [
    /* @__PURE__ */ x(xe, c(n({}, k), { withinPortal: D, children: /* @__PURE__ */ x(
      Ze,
      c(n({}, re), {
        keepMounted: A,
        mounted: !H && !!f.opened,
        duration: f.isGroupPhase ? 10 : re.duration,
        children: (ze) => {
          var ae, ie;
          return /* @__PURE__ */ Q(
            we,
            c(n(c(n({}, Se), {
              "data-fixed": T === "fixed" || void 0,
              variant: Z,
              mod: [{ multiline: I }, G]
            }), f.getFloatingProps({
              ref: f.floating,
              className: q("tooltip").className,
              style: c(n(n({}, q("tooltip").style), ze), {
                zIndex: Y,
                top: (ae = f.y) != null ? ae : 0,
                left: (ie = f.x) != null ? ie : 0
              })
            })), {
              children: [
                s,
                /* @__PURE__ */ x(
                  Ve,
                  n({
                    ref: te,
                    arrowX: f.arrowX,
                    arrowY: f.arrowY,
                    visible: M,
                    position: f.placement,
                    arrowSize: F,
                    arrowOffset: R,
                    arrowRadius: E,
                    arrowPosition: C
                  }, q("arrow"))
                )
              ]
            })
          );
        }
      })
    ) })),
    ge(
      r,
      f.getReferenceProps(c(n({
        onClick: z,
        onMouseEnter: V,
        onMouseLeave: w,
        onMouseMove: t.onMouseMove,
        onPointerDown: t.onPointerDown,
        onPointerEnter: t.onPointerEnter,
        className: Ye(O, ne.className)
      }, ne), {
        [h]: Le
      }))
    )
  ] });
});
S.classes = U;
S.displayName = "@mantine/core/Tooltip";
S.Floating = ee;
S.Group = oe;
const xo = "Tooltip-module__root___oJYMp", Ro = {
  root: xo
}, Bo = $e.forwardRef((h, i) => {
  var s = h, {
    children: e,
    label: o,
    position: t
  } = s, r = j(s, [
    "children",
    "label",
    "position"
  ]);
  const v = t && (t.startsWith("left") || t.startsWith("right"));
  return /* @__PURE__ */ x(
    S,
    c(n({
      arrowOffset: v ? 8 : 16,
      arrowPosition: "side",
      events: { hover: !0, focus: !0, touch: !1 },
      label: o,
      offset: 4,
      position: t,
      ref: i,
      withArrow: !0,
      classNames: Ro
    }, r), {
      children: e
    })
  );
});
export {
  Bo as T,
  S as a
};
